import styled, { css } from 'styled-components'

interface ButtonProps {
  direction: 'forward' | 'backward'
  notAvailable: boolean
}

export const ButtonStyle = styled.button<ButtonProps>`
  position: relative;
  width: 24px;
  height: 24px;

  @media (max-width: 300px) {
    margin: 0 2px;
  }

  ${({ notAvailable, theme }) =>
    notAvailable
      ? css`
          border: none;
          background-color: ${theme.colors.colorf3f5f9};
          pointer-events: none;

          svg {
            fill: ${theme.colors.colorDCE3ED};
          }
        `
      : css`
          border: 1px solid ${theme.colors.colorDCE3ED};
          background-color: transparent;

          &:hover {
            border: 1px solid ${props => props.theme.colors.color5a6a7e};
          }

          svg {
            fill: ${props => props.theme.colors.color1f6ecd};
          }
        `}

  border-radius: 4px;
  cursor: pointer;

  & svg {
    transform: ${({ direction }) => (direction === 'backward' ? 'rotate(90deg)' : 'rotate(-90deg)')};
  }
`
